<script setup lang="ts">
import { SellerShopCompanyQuery } from '@gql/SellerShopCompanyQuery'

const t2 = useT2({
  'Company Name': 'Įmonės pavadinimas',
  'Company Details': 'Įmonės rekvizitai',
  'Company Code': 'Įmonės kodas',
  'VAT number': 'PVM mokėtojo kodas',
  Address: 'Adresas',
  'Bank Name': 'Banko pavadinimas',
  'Account Number (IBAN)': 'Sąskaitos numeris (IBAN)',
  'Branch Code': 'Skyriaus kodas',
})
// const { seller } = useSeller('server')

useHead({
  title: t2('Company Details'),
})
// useServerHead({
//   script: [
//     seoSchema([
//       {
//         '@type': 'AboutPage',
//         mainEntity: {
//           '@type': 'Organization',
//           name: 'Example Company',
//           url: 'https://www.example.com',
//           logo: 'https://www.example.com/logo.png',
//           foundingDate: '2010-01-01',
//           founder: {
//             '@type': 'Person',
//             name: 'Jane Smith',
//           },
//           address: {
//             '@type': 'PostalAddress',
//             streetAddress: '123 Main Street',
//             addressLocality: 'Anytown',
//             addressRegion: 'State',
//             postalCode: '12345',
//             addressCountry: 'Country',
//           },
//           contactPoint: contactPoint(),
//           sameAs: sameAs(),
//           description: 'Example Company is a leading provider of innovative solutions in the tech industry. We specialize in creating high-quality products that enhance the lives of our customers.',
//           employee: [
//             {
//               '@type': 'Person',
//               name: 'John Doe',
//               jobTitle: 'Chief Executive Officer',
//               image: 'https://www.example.com/images/john-doe.jpg',
//             },
//             {
//               '@type': 'Person',
//               name: 'Emily Johnson',
//               jobTitle: 'Chief Technology Officer',
//               image: 'https://www.example.com/images/emily-johnson.jpg',
//             },
//           ],
//         },
//       },

//       {
//         '@type': 'AboutPage',
//         mainEntity: {
//           '@type': 'Organization',
//           name: 'Example Company',
//           url: 'https://www.example.com',
//           logo: 'https://www.example.com/logo.png',
//           foundingDate: '2010-01-01',
//           numberOfEmployees: '250',
//           award: 'Best Tech Startup 2023',
//           address: {
//             '@type': 'PostalAddress',
//             streetAddress: '123 Main Street',
//             addressLocality: 'Anytown',
//             addressRegion: 'State',
//             postalCode: '12345',
//             addressCountry: 'Country',
//           },
//           contactPoint: contactPoint(),
//           sameAs: sameAs(),
//           description: 'Example Company is a leading provider of innovative solutions in the tech industry.',

//         },
//       },
//     ]),
//   ],
// })

// This section usually includes:

// Company registration information
// Bank account details
// Tax/VAT numbers
// Legal address
const sellerId = useSellerId('retail')

const { ui } = useApolloWrap2<gen.SellerShopCompanyQuery, gen.SellerShopCompanyQueryVariables>(SellerShopCompanyQuery)({
  vars: () => ({ handle: sellerId.value }),
  ui: (i) => i?.publicSeller?.doc?.invoiceDetails,
})
</script>

<template>
  <AppMenu :title="t2('Company Details')">
    <template #content>
      <div class="_col _gap1">
        <div class="_col _gap1 _pr4 _pb2">
          <UiLineDetails :label="t2('Company Name')" :value="ui?.companyName?.value" />
          <UiLineDetails :label="t2('Company Code')" :value="ui?.companyCode" />
          <UiLineDetails :label="t2('VAT number')" :value="ui?.companyVAT" />
          <UiLineDetails :label="t2('Address')" :value="ui?.comanyAddress?.value" />
        </div>

        <div class="_col _gap1">
          <UiLineDetails :label="t2('Bank Name')" :value="ui?.invoiceBank?.value" />
          <UiLineDetails :label="t2('Account Number (IBAN)')" :value="ui?.invoiceBankAccount" />
          <UiLineDetails :label="t2('Branch Code')" :value="ui?.invoiceBankCode" />
          <UiLineDetails :label="ts('BIC/SWIFT')" :value="ui?.SWIFT" />
        </div>
      </div>
    </template>
  </AppMenu>
</template>
